'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/8/8.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Header = require('../Header/Header');

var _Header2 = _interopRequireDefault(_Header);

var _reactRedux = require('react-redux');

var _shopDetail = require('redux/modules/shopDetail');

var _reduxAsyncConnect = require('redux-async-connect');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _attentionShop = require('redux/modules/attentionShop');

var _reactRouter = require('react-router');

var _background = require('redux/modules/background');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopDetail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var params = _ref.params;

    if (!(0, _shopDetail.isLoaded)(getState())) {
      var promises = [];
      promises.push(dispatch((0, _shopDetail.load)(params.shopId)));
      promises.push(dispatch((0, _background.changeHeaderText)('店铺主页')));
      return _promise2.default.all(promises);
    }
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.shopDetail.data,
    attentionData: state.attentionShop.addData
  };
}, {
  addToAttention: _attentionShop.add,
  routerPush: _reactRouterRedux.push,
  clearAddInfo: _attentionShop.clearAdd,
  getAttentionState: _shopDetail.getShopAttentionStateData
}), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ShopDetail, _Component);

  function ShopDetail() {
    (0, _classCallCheck3.default)(this, ShopDetail);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ShopDetail).call(this));

    _this.state = {
      headerActiveIndex: 0,
      attentionModelOpen: false
    };
    return _this;
  }

  (0, _createClass3.default)(ShopDetail, [{
    key: 'onCloseSuccessModal',
    value: function onCloseSuccessModal() {
      var clearAddInfo = this.props.clearAddInfo;
      var attentionModelOpen = this.state.attentionModelOpen;

      if (attentionModelOpen) {
        this.setState({
          attentionModelOpen: false
        });
      } else {
        if (clearAddInfo) {
          clearAddInfo();
        }
      }
    }
  }, {
    key: 'onHomeItemClick',
    value: function onHomeItemClick() {
      var _props = this.props;
      var location = _props.location;
      var routerPush = _props.routerPush;

      if (location) {
        var query = location.query;

        if (query) {
          var fromProduct = query.fromProduct;
          var isCustom = query.isCustom;

          if (fromProduct) {
            if (routerPush) {
              if (isCustom === '1') {
                routerPush('/customproduct/' + fromProduct);
              } else {
                routerPush('/product/' + fromProduct);
              }
            }
          }
        }
      }
    }
  }, {
    key: 'onArticleClick',
    value: function onArticleClick() {
      this.setState({
        isGroupBuyingModalOpened: true
      });
    }

    /*
     onDesignerMouseOver(designerId) {
     if (this.state.designerShowID !== designerId) {
     this.setState({
     designerShowID: designerId
     });
     }
     }*/

  }, {
    key: 'onShopNavClick',
    value: function onShopNavClick(shopId) {
      var routerPush = this.props.routerPush;

      if (routerPush) {
        routerPush('/shopproductList/' + shopId);
      }
    }
  }, {
    key: 'onDesignerNavClick',
    value: function onDesignerNavClick(shopId) {
      var routerPush = this.props.routerPush;

      if (routerPush) {
        routerPush('/shopdesignerList/' + shopId);
      }
    }
  }, {
    key: 'onVRNavClick',
    value: function onVRNavClick(VRid) {
      var url = 'http://vr.craftschina.cn:8080/putout/1/' + VRid + '/pano/';
      window.open(url);
    }
  }, {
    key: 'activeChange',
    value: function activeChange(nextSection) {
      this.setState({
        headerActiveIndex: nextSection
      });
    }
  }, {
    key: 'isContentToShow',
    value: function isContentToShow(item) {
      for (var _index = 0; _index < item.length; _index++) {
        if (item[_index].img) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'addToAttention',
    value: function addToAttention(shopId) {
      var _this2 = this;

      var _props2 = this.props;
      var params = _props2.params;
      var addToAttention = _props2.addToAttention;
      var getAttentionState = _props2.getAttentionState;
      var data = _props2.data;
      var shopDetailAttentionState = data.shopDetailAttentionState;

      var currentShopId = shopId;
      if (!currentShopId) {
        currentShopId = params.productId;
      }
      if (addToAttention) {
        if (shopDetailAttentionState instanceof Array && shopDetailAttentionState[0].isAttention === '1') {
          this.setState({
            attentionModelOpen: true
          });
        } else if (shopDetailAttentionState instanceof Array && shopDetailAttentionState[0].isAttention === '0') {
          addToAttention(currentShopId).then(function (nextData) {
            // console.log(nextData);
            if (nextData.isValid) {
              getAttentionState(currentShopId);
            }
          });
        } else {
          getAttentionState(currentShopId).then(function (nextData) {
            // console.log(nextData);
            if (nextData.isValid && nextData.shopDetailAttentionState instanceof Array) {
              _this2.addToAttention(currentShopId);
            }
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state;
      var headerActiveIndex = _state.headerActiveIndex;
      var attentionModelOpen = _state.attentionModelOpen;
      var _props3 = this.props;
      var data = _props3.data;
      var params = _props3.params;

      var resultDiv = _react2.default.createElement('div', null);
      if (data) {
        (function () {
          var shopInfoHome = data.shopInfoHome;
          var shopInfoShop = data.shopInfoShop;
          var shopInfoProducts = data.shopInfoProducts;
          var shopInfoDesigner = data.shopInfoDesigner;
          var shopInfoStory = data.shopInfoStory;
          var shopInfoOwner = data.shopInfoOwner;
          var shopInfoAptitude = data.shopInfoAptitude;
          var shopInfoBasic = data.shopInfoBasic;
          var attentionData = _this3.props.attentionData;

          var isAttentionModalOpened = false;
          var attentionErrorMsg = '';
          if (attentionData) {
            if (attentionData.isValid) {
              attentionErrorMsg = '关注成功';
            } else {
              attentionErrorMsg = attentionData.errorMsg;
            }
            isAttentionModalOpened = true;
          }

          if (attentionModelOpen) {
            attentionErrorMsg = '店铺已关注';
            isAttentionModalOpened = attentionModelOpen;
          }

          var styles = require('../ProductDetails/ProductDetails.scss');

          var anchors = ['shopInfoFirstPage'];
          var array = [{
            text: '首页',
            href: 'shopInfoFirstPage',
            type: 'nav',
            icon: 'icon01'
            // onClick: this.onHomeItemClick.bind(this)
          }];

          // 以下为测试数据， 模拟shopInfoDesigner
          /*
           const imagesTest = [ {
           id: 1,
           name: 'test1',
           img: 'http://tupian.goeasy.cn:9999/yipinwang/third/bk1.jpg'
           }, {
           id: 2,
           name: 'test2',
           img: 'http://tupian.goeasy.cn:9999/yipinwang/third/bk2.jpg'
           }, {
           id: 3,
           name: 'test3',
           img: 'http://tupian.goeasy.cn:9999/yipinwang/third/bk3.jpg'
           } ];
           */
          // 结束
          var contentDiv = [_react2.default.createElement(
            _components.FullPageSection,
            { key: '0', className: styles.goeasySection },
            _react2.default.createElement(
              'div',
              { className: styles.header },
              _react2.default.createElement(_Header2.default, null)
            ),
            shopInfoHome instanceof Array && _this3.isContentToShow(shopInfoHome) ? _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem },
              _react2.default.createElement(_components.ProductInfoFirstCarousel, { first: true, images: shopInfoHome })
            ) : _react2.default.createElement(
              'div',
              { className: styles.firstFullPageItem, style: { paddingTop: 100, fontSize: 20, textAlign: 'center' } },
              '店铺资料维护中......'
            ),
            _react2.default.createElement('img', { onClick: function onClick() {
                return _this3.addToAttention(params.shopId);
              }, className: styles.appreciationImg,
              src: 'http://tupian.goeasy.cn:9999/yipinwang/third/zbutn1.png', alt: '' })
          )];

          /*
           <FullPageSection key="2" className={styles.goeasySection}>
           {
           shopInfoProducts instanceof Array && shopInfoProducts instanceof Array ?
           <ImgsWallOfDetail data={shopInfoProducts} type="product"
           backgroundData={shopInfoProductsBackground}/> : ''}
           </FullPageSection>
           */

          if (shopInfoShop instanceof Array && shopInfoShop.length > 0) {
            if (_this3.isContentToShow(shopInfoShop)) {
              anchors.push('shopInfoShop');
              array.push({
                text: '介绍',
                href: 'shopInfoShop',
                type: 'nav',
                icon: 'icon02'
              });
              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '1', className: styles.goeasySection },
                _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: shopInfoShop })
              ));
            }
          }

          if (shopInfoStory instanceof Array && shopInfoStory.length > 0) {
            if (_this3.isContentToShow(shopInfoStory)) {
              anchors.push('shopInfoStory');
              array.push({
                text: '故事',
                href: 'shopInfoStory',
                type: 'nav',
                icon: 'icon06'
              });
              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '2', className: styles.goeasySection },
                _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: shopInfoStory })
              ));
            }
          }

          if (shopInfoOwner instanceof Array && shopInfoOwner.length > 0) {
            if (_this3.isContentToShow(shopInfoOwner)) {
              anchors.push('shopInfoOwner');
              array.push({
                text: '店主',
                href: 'shopInfoOwner',
                type: 'nav',
                icon: 'icon07'
              });
              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '3', className: styles.goeasySection },
                _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: shopInfoOwner })
              ));
            }
          }

          if (shopInfoProducts instanceof Array && shopInfoProducts.length > 0 && _this3.isContentToShow(shopInfoProducts)) {
            anchors.push('shopInfoProducts');
            array.push({
              text: '艺品',
              href: 'shopInfoProducts',
              type: 'nav',
              icon: 'icon23'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '4', className: styles.goeasySection },

              //  <AccordionComponent images={shopInfoProducts} type="product"/>
              shopInfoProducts instanceof Array && shopInfoProducts instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: shopInfoProducts }) : '',
              _react2.default.createElement(
                'div',
                { className: styles.visitDiv },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/shopproductlist/' + params.shopId,
                    className: styles.visitBtn },
                  _react2.default.createElement('img', {
                    src: 'http://tupian.goeasy.cn:9999/yipinwang/third/more.png' })
                )
              )
            ));
          } else {
            array.push({
              text: '艺品',
              type: 'pop',
              icon: 'icon23',
              onClick: function onClick() {
                return _this3.onShopNavClick(params.shopId);
              }
            });
          }

          if (shopInfoDesigner instanceof Array && shopInfoDesigner.length > 0 && _this3.isContentToShow(shopInfoDesigner)) {
            anchors.push('shopInfoDesigner');
            array.push({
              text: '作者',
              href: 'shopInfoDesigner',
              type: 'nav',
              icon: 'icon05'
            });
            contentDiv.push(_react2.default.createElement(
              _components.FullPageSection,
              { key: '5', className: styles.goeasySection },

              //  <AccordionComponent images={shopInfoProducts} type="product"/>
              shopInfoDesigner instanceof Array && shopInfoDesigner instanceof Array ? _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: shopInfoDesigner }) : '',
              _react2.default.createElement(
                'div',
                { className: styles.visitDiv },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/shopdesignerlist/' + params.shopId,
                    className: styles.visitBtn },
                  _react2.default.createElement('img', {
                    src: 'http://tupian.goeasy.cn:9999/yipinwang/third/more.png' })
                )
              )
            ));
          } else {
            array.push({
              text: '作者',
              type: 'pop',
              icon: 'icon05',
              onClick: function onClick() {
                return _this3.onDesignerNavClick(params.shopId);
              }
            });
          }
          /*
           if (shopInfoDesigner instanceof Array) {
           if (this.isContentToShow(shopInfoDesigner)) {
           anchors.push('shopInfoDesigner');
           array.push({
           text: '设计师',
           href: 'shopInfoDesigner',
           type: 'nav',
           icon: 'icon05'
           });
           contentDiv.push((<FullPageSection key="5" className={styles.goeasySection}>
           <ProductInfoFirstCarousel images={shopInfoDesigner}/>
           {
           shopInfoDesigner instanceof Array && shopInfoDesigner.length > 0 ?
           (<div className={styles.visitDiv}>
           <Link to={'/designer/' + shopInfoDesigner[0].id}
           className={styles.visitBtn}
           target="_blank"><img src="http://tupian.goeasy.cn:9999/yipinwang/third/zbutn8.png"/></Link>
           </div>) : ''
           }
           </FullPageSection>));
           }
           } */
          if (shopInfoBasic instanceof Array && shopInfoBasic.length > 0) {
            if (shopInfoBasic[0].VRid) {
              array.push({
                text: 'VR店铺',
                type: 'pop',
                icon: 'icon24',
                onClick: function onClick() {
                  return _this3.onVRNavClick(shopInfoBasic[0].VRid);
                }
              });
            }
          }

          if (shopInfoAptitude instanceof Array && shopInfoAptitude.length > 0) {
            if (_this3.isContentToShow(shopInfoAptitude)) {
              anchors.push('shopInfoAptitude');
              array.push({
                text: '资质',
                href: 'shopInfoAptitude',
                type: 'nav',
                icon: 'icon09'
              });
              contentDiv.push(_react2.default.createElement(
                _components.FullPageSection,
                { key: '6', className: styles.goeasySection },
                _react2.default.createElement(_components.ProductInfoFirstCarousel, { images: shopInfoAptitude })
              ));
            }
          }
          /*
           array.push({
           text: '文章',
           type: 'pop',
           icon: 'icon10',
           onClick: this.onArticleClick.bind(this)
           });*/
          var options = {
            sectionClassName: 'section',
            anchors: anchors,
            scrollBar: false,
            activeClass: styles.active,
            navigation: false,
            verticalAlign: false,
            sectionPaddingTop: '0',
            sectionPaddingLeft: '0',
            sectionPaddingRight: '0',
            sectionPaddingBottom: '0'
          };
          resultDiv = _react2.default.createElement(
            'div',
            { className: styles.component },
            headerActiveIndex === 0 ? _react2.default.createElement(
              'a',
              { className: styles.nextIcon, href: '#shopInfoShop' },
              _react2.default.createElement('img', {
                src: 'http://tupian.goeasy.cn:9999/yipinwang/xiala.png', alt: '' })
            ) : '',
            _react2.default.createElement(
              _components.FullPageHeader,
              null,
              _react2.default.createElement(_components.GoeasyFullPageHeader, { content: array, headerActiveIndex: headerActiveIndex })
            ),
            _react2.default.createElement(
              _components.FullPageSectionsContainer,
              (0, _extends3.default)({ activeChange: _this3.activeChange.bind(_this3),
                className: 'container' }, options),
              contentDiv
            ),
            _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: isAttentionModalOpened, closeModalFunc: _this3.onCloseSuccessModal.bind(_this3),
              loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/guanzhu_sucess_1.png") no-repeat' },
              text: attentionErrorMsg })
          );
        })();
      }
      return resultDiv;
    }
  }]);
  return ShopDetail;
}(_react.Component), _class2.propTypes = {
  data: _react.PropTypes.object.isRequired,
  attentionData: _react.PropTypes.object,
  dispatch: _react.PropTypes.func,
  addToAttention: _react.PropTypes.func,
  clearAddInfo: _react.PropTypes.func,
  location: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  params: _react.PropTypes.object,
  getAttentionState: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = ShopDetail;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ShopDetail/ShopDetail.js
 ** module id = 1543
 ** module chunks = 0
 **/